// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// export default function FTL() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Setting-up/Up-gradation of Food Testing Laboratories from MOFPI</h1>

//                                   <h2>About Setting Up/Up-gradation of Quality Control/Food Testing Laboratories</h2>
//                                   <p>About Setting Up/Up-gradation of Quality Control/Food Testing Laboratories</p>
//                                   <p>In the interest of consumer safety and public health, there is a need for testing food products to ensure that it complies with domestic standards as well as international standards for exports. There is also a need for testing of all imported food products to ensure that they are of the requisite standard and food products not permitted for manufacture domestically are not allowed to come in from foreign markets. Apart from this, the level of contaminants, additives, and pesticide residues in food items is required to be monitored regularly. Therefore, a network of food testing and analysis laboratories is required to support the surveillance system of food regulator, timely analysis of samples and ensure compliance of international and domestic standards on food in case of exports as well as imports.</p>
//                                   <p>Under the scheme, Central/ State Government, and their organizations/ Government universities (including deemed universities) and all other implementing agencies/private sector organizations/universities (including deemed universities) are eligible to receive financial assistance for setting up of food testing laboratories.</p>
//                                   <p>List of Assisted Project under FTL</p>
                                
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Pattern of Assistance</h2>
//                                   <p>Central/State Government and its organizations /universities (including Govt. owned deemed universities) are eligible for grant-in-aid of entire cost of laboratory equipment and 25% of the cost of technical civil work to house the equipment and furniture and fixtures associated with the equipment for general areas and 33% for difficult areas. In addition, they are also eligible for 80% of the monthly emoluments of two technical staff for two years from the date of completion of the laboratory.</p>
//                                  <p>All other implementing agencies/private sector organizations/ universities including deemed universities will be eligible for grant-in-aid of 50% of cost of laboratory equipment and 25% of the cost of technical civil work to house the Equipment and furniture and fixtures associated with the equipment for general areas and 70% of cost of lab equipment and 33% of technical civil work and furniture and fixtures for difficult areas.</p>

//                                   <p>When the Ministry establishes / sponsors such food testing laboratories, there would be no ceiling to financial assistance and the amount to be approved will be decided on case-to-case basis with the approval of Competent Authority.</p>
//                                   <p>Implementation procedure</p>
//                                   <p>1. All the proposals received for financial assistance are placed before Techno Scrutiny Committee (TSC) constituted by MOFPI for examining such proposals from technical angle. Applicant organizations will make presentations before TSC. The organizations will have to furnish formation/documents as sought by TSC.</p>
//                                   <p>2. Thereafter, the proposals recommended by TSC from technical angle and complete in all respects are placed before Project Approval Committee (PAC) for consideration and approval.</p>
//                                   <p>Pattern of Release of Funds</p>
//                                   <p>(1) Central/State Government and its organizations /universities (including Govt. owned deemed universities)</p>
//                                   <p>1st installment of 40% of the total grant is released after receiving requisite documents prescribed under the scheme.</p>
//                                   <p>2nd installment of 40% of the total grant is released after ensuring full utilization of 1st installment of grant towards purchase of lab equipment, expenditure on Technical Civil Work (TCW) and fixing of Furniture & Fixtures for housing the equipment.</p>
//                                   <p>3rd installment of 20% of the total grant is released after ensuring full utilization of 2nd installment of grant towards purchase of lab equipment, completion of Technical Civil Works (TCW) and fixing of Furniture & Fixtures for housing the equipment.</p>
//                                   <p>4th and final installment comprising the emoluments at the rate of 80 percent for the two technical staff for 2 years is released after all the PAC approved equipment are purchased, installed and on submission of the utilization certificate for 3rd installment along with the status of NABL accreditation.</p>
//                                   <p>(2) All other implementing agencies/ private sector organizations/ universities including deemed universities</p>
//                                   <p>1st installment of 40% of the total grant is released after ensuring that 40% of the promoter’s contribution and 40% of the term loan has been spent on the project.</p>
//                                   <p>2nd installment of another 40% of the total grant is released after ensuring utilization of first installment of grant and utilization of 80% of promoter’s contribution and 80% of term loan.</p>
//                                   <p>3rd and final installment of remaining 20% of the is released after ensuring utilization of the second installment and utilization of 100% of promoter’s contribution and 100% of term loan.</p>
                              
//                               <h2>How Enrich Services Help You?</h2>
//                               <p>Enrich Services will help you to guide the procedure, we assist in getting you the maximum benefit for your business through the quality preparation of documents, representation and coordination with various targeted departments and help you in timely and hassle free availability of incentives and grants</p>
                              
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaIndustry,
  FaRocket,
  FaHandsHelping,
  FaList
} from "react-icons/fa";

export default function FTL() {
  return (
    <div className="bg-light py-5">
      <Container>

        {/* TITLE */}
        <Row>
          <Col>
            <h1>
              Food Testing Laboratories (FTL) – MoFPI
            </h1>

            <p>
              The FTL Scheme supports the establishment and upgradation of food
              testing laboratories to ensure quality, safety, and export compliance.
            </p>
          </Col>
        </Row>

        {/* OVERVIEW */}
        <h2 className="section-title">
          <FaGlobe /> Scheme Overview
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Strengthens food safety infrastructure</li>
          <li><FaCheckCircle /> Ensures compliance with global standards</li>
          <li><FaCheckCircle /> Supports export quality testing</li>
          <li><FaCheckCircle /> Monitors contaminants & residues</li>
        </ul>

        {/* ELIGIBILITY */}
        <h2 className="section-title">
          <FaList /> Eligibility
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Government institutions</li>
          <li><FaCheckCircle /> Universities & research institutions</li>
          <li><FaCheckCircle /> Private companies</li>
          <li><FaCheckCircle /> Implementing agencies</li>
        </ul>

        {/* FINANCIAL ASSISTANCE */}
        <h2 className="section-title">
          <FaRocket /> Financial Assistance
        </h2>

        <h3>🏛 Government Institutions</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> 100% grant for lab equipment</li>
          <li><FaCheckCircle /> 25%–33% for civil work</li>
          <li><FaCheckCircle /> 80% salary support (2 years)</li>
        </ul>

        <h3>🏢 Private Sector</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> 50% grant (General areas)</li>
          <li><FaCheckCircle /> 70% grant (Difficult areas)</li>
          <li><FaCheckCircle /> 25%–33% civil work support</li>
        </ul>

        <p>
          👉 No upper limit when labs are set up directly by the Ministry
          (case-to-case approval).
        </p>

        {/* PROCESS */}
        <h2 className="section-title">
          <FaIndustry /> Implementation Process
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Technical evaluation by TSC</li>
          <li><FaCheckCircle /> Proposal review & presentation</li>
          <li><FaCheckCircle /> Approval by PAC</li>
        </ul>

        {/* FUND RELEASE */}
        <h2 className="section-title">
          <FaRocket /> Release of Funds
        </h2>

        <h3>🏛 Government</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> 40% – Initial</li>
          <li><FaCheckCircle /> 40% – After utilization</li>
          <li><FaCheckCircle /> 20% – Final completion</li>
        </ul>

        <h3>🏢 Private</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> 40% – Initial investment</li>
          <li><FaCheckCircle /> 40% – Mid progress</li>
          <li><FaCheckCircle /> 20% – Final completion</li>
        </ul>

        {/* IMPORTANCE */}
        <h2 className="section-title">
          <FaGlobe /> Why Food Testing Labs Matter
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Ensures consumer safety</li>
          <li><FaCheckCircle /> Enables export compliance</li>
          <li><FaCheckCircle /> Prevents unsafe products</li>
          <li><FaCheckCircle /> Supports regulatory systems</li>
        </ul>

        {/* HELP */}
        <h2 className="section-title">
          <FaHandsHelping /> How We Help You
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> DPR preparation</li>
          <li><FaCheckCircle /> Application filing</li>
          <li><FaCheckCircle /> MoFPI coordination</li>
          <li><FaCheckCircle /> NABL readiness support</li>
          <li><FaCheckCircle /> End-to-end execution</li>
        </ul>

        {/* WHY */}
        <h2 className="section-title">
          <FaRocket /> Why Choose Apex
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Expert consultancy</li>
          <li><FaCheckCircle /> Fast approvals</li>
          <li><FaCheckCircle /> High success rate</li>
          <li><FaCheckCircle /> Complete compliance support</li>
        </ul>

      </Container>
    </div>
  );
}